import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { MatTableExporterModule } from 'mat-table-exporter';
import { BreadcrumbsModule } from 'src/@vex/components/breadcrumbs/breadcrumbs.module';
import { PageLayoutModule } from 'src/@vex/components/page-layout/page-layout.module';
import { AppMaterialModule } from 'src/app/app.material.module';
import { CasoRoutingModule } from './caso-routing.module';
import { DesaparecidoFormComponent } from './desaparecido/desaparecido-form/desaparecido-form.component';
import { DesaparecidoListComponent } from './desaparecido/desaparecido-list/desaparecido-list.component';
import { GrupoFormComponent } from './grupo/grupo-form/grupo-form.component';
import { GrupoListComponent } from './grupo/grupo-list/grupo-list.component';
import { GrupoSocioFormComponent } from './grupo/grupo-socio/grupo-socio-form/grupo-socio-form.component';
import { NotificacionFormComponent } from './notificacion/notificacion-form/notificacion-form.component';
import { NotificacionListComponent } from './notificacion/notificacion-list/notificacion-list.component';
import { SocioFormComponent } from './socio/socio-form/socio-form.component';
import { SocioListComponent } from './socio/socio-list/socio-list.component';
import { ReporteListComponent } from './reporte/reporte-list/reporte-list.component';
import { MonitorFormComponent } from './monitor/monitor-form/monitor-form.component';
import { MonitorListComponent } from './monitor/monitor-list/monitor-list.component';
import { PublicadodoListComponent } from './monitor/publicado-list/publicado-list.component';
import { PublicadoFormComponent } from './monitor/publicado-form/publicado-form.component';
import { ConfigComponent } from './monitor/config/config.component';
import { PublicadoViewComponent } from './monitor/publicacion-view/publicado-view.component';
import { MensajeFormComponent } from './notificacion/mensaje-form/mensaje-form.component';

@NgModule({
  declarations: [
    DesaparecidoListComponent,
    DesaparecidoFormComponent,
    SocioFormComponent,
    SocioListComponent,
    GrupoListComponent,
    GrupoFormComponent,
    GrupoSocioFormComponent,
    NotificacionListComponent,
    NotificacionFormComponent,
    MensajeFormComponent,
    ReporteListComponent,
    MonitorListComponent,
    MonitorFormComponent,
    PublicadodoListComponent,
    PublicadoFormComponent,
    PublicadoViewComponent,
    ConfigComponent
  ],
  imports: [
    CommonModule,
    MatIconModule,
    CasoRoutingModule,
    AppMaterialModule,
    PageLayoutModule,
    BreadcrumbsModule,
    FormsModule,
    ReactiveFormsModule,
    MatTableExporterModule,
    MatRadioModule
  ]
})
export class CasoModule { }
